import * as React from 'react';
import { Size, Tone, Palette, Appearance } from "./Chip.types";
import { BaseChip } from "./BaseChip";
import { ClickableHoverableWrapper } from "./ClickableHoverableWrapper"; // Dark Tone Chip - cannot have icons

export var DarkToneChip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$palette = _ref.palette,
      palette = _ref$palette === void 0 ? Palette.primary : _ref$palette,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? Appearance.solid : _ref$appearance,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? Size.medium : _ref$size,
      onClick = _ref.onClick,
      onMouseOver = _ref.onMouseOver,
      onMouseOut = _ref.onMouseOut,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(ClickableHoverableWrapper, {
    onClick: onClick,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut
  }, /*#__PURE__*/React.createElement(BaseChip, {
    ref: ref,
    children: children,
    size: size,
    tone: Tone.dark,
    palette: palette,
    appearance: appearance
  }));
});